export default __webpack_public_path__ + "static/media/img-0412-austria-half-face.181676d1.png";